import { Pin } from 'lucide-react';
import { useArtifactPanelStore } from '@/stores/artifactPanelStore.js';
import { Section } from './Section.js';
import { ArtifactItem } from './ArtifactItem.js';
import { useAppContext } from '@/contexts/AppContext.js';

export function PinnedSection() {
  const pinnedIds = useArtifactPanelStore((state) => state.pinnedIds);
  const artifacts = useArtifactPanelStore((state) => state.artifacts);
  const sections = useArtifactPanelStore((state) => state.sections);
  const toggleSection = useArtifactPanelStore((state) => state.toggleSection);
  const openTab = useArtifactPanelStore((state) => state.openTab);
  const togglePin = useArtifactPanelStore((state) => state.togglePin);
  const deleteArtifact = useArtifactPanelStore((state) => state.deleteArtifact);
  const activeTabId = useArtifactPanelStore((state) => state.activeTabId);
  const openTabs = useArtifactPanelStore((state) => state.openTabs);

  const { deleteNote } = useAppContext();

  // Function to handle deletion (handles both notes and other artifact types)
  const handleDelete = (artifactId: string, artifactType: string) => {
    // If it's a note, delete from AppContext too
    if (artifactType === 'note') {
      const noteId = artifactId.replace('note-', '');
      deleteNote(noteId);
    }

    // Delete from artifact store
    deleteArtifact(artifactId);
  };

  const pinnedArtifacts = pinnedIds
    .map((id) => artifacts[id])
    .filter((a) => a !== undefined);

  if (pinnedArtifacts.length === 0) {
    return null;
  }

  return (
    <Section
      title="Pinned"
      icon={<Pin className="h-3.5 w-3.5 text-muted-foreground" />}
      collapsed={sections.pinned.collapsed}
      onToggle={() => toggleSection('pinned')}
    >
      {pinnedArtifacts.map((artifact) => (
        <ArtifactItem
          key={artifact.id}
          artifact={artifact}
          isActive={activeTabId === artifact.id}
          isOpen={openTabs.includes(artifact.id)}
          onClick={() => openTab({ id: artifact.id, type: artifact.type, title: artifact.title, data: artifact.data })}
          onPin={() => togglePin(artifact.id)}
          onDelete={() => handleDelete(artifact.id, artifact.type)}
        />
      ))}
    </Section>
  );
}
